export const config = {
    "theme": {
        "bs-primary-color": "#2596be",
        "bs-secondary-color": "#9cd4b2",
        // other color #6e6e72
        "bs-text-primary-color": "#135963",
        "bs-text-secondary-color": "#5c5c5c",
        "bs-text-white": "#fff",
        "bs-text-mandatory": "#ff0000",
        "bs-breadcrumb-color": "#ededed",
        "bs-active-breadcrumb-color": "#000000",
        "bs-disabled-color": "#ededed",
        "bs-border-color": "#ededed",
        "bs-hr": "#ededed",
        "bs-table-border": "#ededed",
        "bs-table-header": "#d7e7ea",
        "bs-table-row": "#f2f2f2",
        "bs-toast-header": "#d7e7ea",
        "bs-theme-background-color": "#2596be"
    },
    "logo": {
        "loader": "assets/images/logo/healthcoop/healthcoopLoader.jpg",
        "main": "assets/images/logo/healthcoop/healthcoopMain.jpg",
        "favicon": "assets/images/favicon/healthcoop/favicon.ico",
        "banner": "assets/images/banners/veridy/banner.jpg",
        "loginBanner": "assets/images/background/veridy/veridy-bg-image.jpg"
    },
    "contact": {
        "copyright": "",
        "phone": "",
        "servicePhone": "",
        "salesPhone": "",
        "fax": "",
        "email": "",
        "serviceEmail": "",
        "salesEmail": "",
        "address": {
            "lineOne": "",
            "lineTwo": "",
            "lineThree": ""
        }
    },
    "configuration": {
        "siteTitle": "Primus Health",
        "header": true,
        "footer": false,
        "privacyLink": true,
        "termsLink": true
    }
};